import React from 'react'
import { useTranslation } from 'react-i18next'
import { DateRange } from 'react-day-picker'

import { Palette } from '../../../themes/useTheme'
import { nightsCount, parseDate } from '../../../core/components/calendar/utils'
import { IconsSvg } from '../../../assets/IconsSvg'
import { SubmitButton } from '../../../core/components'

export const Footer = ({
  calendarHasError,
  calendarRange,
  handleClearDates,
  language,
  palette,
}: {
  calendarHasError: boolean
  calendarRange?: DateRange
  handleClearDates: () => void
  language?: string
  palette: Palette
}) => {
  const { t } = useTranslation()

  const nights = nightsCount({
    calendarRange: calendarRange,
  })

  return (
    <div className="will-calendar-footer-actions-wrapper">
      <div className="will-calendar-footer-dates">
        {calendarHasError ? (
          <div className="will-calendar-footer-error">
            {calendarHasError &&
              renderCalendarErrorMessage({
                palette,
                message: t(
                  `common:errors.calendarErrors.checkInAvailabilityError`
                ),
              })}
          </div>
        ) : (
          <div>
            <span>
              {parseDate({
                date: calendarRange?.from,
                dateFormat: 'EEEEEE d.M.yyyy',
                language,
              }) || t('common:checkIn')}
            </span>
            <span className="will-calendar-footer-dates-separator">-</span>
            <span>
              {parseDate({
                date: calendarRange?.to,
                dateFormat: 'EEEEEE d.M.yyyy',
                language,
              }) || t('common:checkOut')}
            </span>
          </div>
        )}

        <span className="will-calendar-footer-booked">
          {!calendarHasError && nights
            ? `${nights} ${t(`common:${nights === 1 ? 'night' : 'nights'}`)}`
            : ''}
        </span>
      </div>

      <div className="will-calendar-footer-actions">
        <SubmitButton
          onClick={handleClearDates}
          disabled={!calendarRange?.from}
          label={t(`common:clearDates`)}
          variant="text"
        />
      </div>
    </div>
  )
}

/////////

const renderCalendarErrorMessage = ({
  message,
  palette,
}: {
  message?: string
  palette: Palette
}) => (
  <>
    <IconsSvg fill={palette?.error || 'inherit'} size={25} icon="warning" />
    <span>{message || ''}</span>
  </>
)
